/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React, { useEffect, useState } from 'react';
import './HomeHero.css';

function HomeHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 60);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className={`mt-hero ${loaded ? 'is-loaded' : ''}`}>
      <div className="mt-hero__media">
        <video
          className="mt-hero__video"
          src={process.env.PUBLIC_URL + '/videos/intro.mp4'}
          poster={process.env.PUBLIC_URL + '/videos/intro-thumbnail.png'}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        />
        <div className="mt-hero__grain" aria-hidden="true" />
        <div className="mt-hero__vignette" aria-hidden="true" />
      </div>

      <div className="mt-hero__top">
        <span className="mt-hero__meta">N° 01 — Sitio Oficial</span>
        <span className="mt-hero__meta mt-hero__meta--dot">
          <span className="mt-hero__dot" /> On Air · MMXXVI
        </span>
      </div>

      <div className="mt-hero__content">
        <span className="mt-eyebrow mt-hero__eyebrow">Independent Record Label · Est. 2015</span>
        <h1 className="mt-hero__title">
          <span className="mt-hero__titleLine">Mastered</span>
          <span className="mt-hero__titleLine mt-hero__titleLine--italic">Trax</span>
        </h1>
        <p className="mt-hero__tag">
          Música con alma. <em>Una casa para artistas</em> que escriben la próxima
          carta del sonido contemporáneo — desde Guadalajara al mundo.
        </p>

        <div className="mt-hero__ctaRow">
          <a
            className="mt-btn mt-btn--primary"
            href="https://masteredtrax.shop"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Visit the Shop</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a className="mt-btn mt-btn--ghost" href="#latest-release">
            <span>Explore Music</span>
          </a>
        </div>
      </div>

      <div className="mt-hero__bottom">
        <div className="mt-hero__socials">
          <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/masteredtrax/">Instagram</a>
          <span>·</span>
          <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/@MasteredTraxVEVO">YouTube</a>
          <span>·</span>
          <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/OfficialMasteredTrax">Facebook</a>
          <span>·</span>
          <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/MasteredTrax">X / Twitter</a>
        </div>
        <a className="mt-hero__scroll" href="#latest-release" aria-label="Scroll to next section">
          <span>Scroll</span>
          <span className="mt-hero__scrollLine" />
        </a>
      </div>
    </section>
  );
}

export default HomeHero;
